import { render, staticRenderFns } from "./Mother.vue?vue&type=template&id=42d7f8be"
import script from "./Mother.vue?vue&type=script&lang=js"
export * from "./Mother.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports